import common from './common.json';
import permissions from './permissions.json';
import route from './route.json';
export default {
  ...common,
  route,
  permissions
};
